var exports = {
  "X": "SpinnerContainer__y6iiIt",
};

module.exports = exports;
